import { AutocompleteDto } from "api/interfaces/api"
import { IUserDetailsDto } from "api/interfaces/user"
import { ChainServiceAPI } from "api/services/chainServiceAPI"
import { UserServiceAPI } from "api/services/userServiceAPI"
import { useEffect, useState } from "react"
import { appStore } from "stores/appStore"
import { locationStore } from "stores/locationStore/locationStore"
import { userStore } from "stores/userStore/userStore"

export const fetchData = () => {
	const [fetchedLocations, setFetchedLocations] = useState<AutocompleteDto[]>([])
	const [userDetails, setUserDetails] = useState<IUserDetailsDto | null>(null)

	const fetchAllData = async () => {
		try {
			appStore.setIsLoading(true)
			let user: IUserDetailsDto | null = null
			if (userStore.userContext.userId) {
				user = (await UserServiceAPI.getById(userStore.userContext.userId)).data
				setUserDetails(user)
			}
			if (user?.chainId) {
				const locations = await ChainServiceAPI.getLocations(user?.chainId);
				setFetchedLocations(locations.data);
				locationStore.setLocationsCount(locations.data.length);
			}
		} catch (error) {
		}
		finally {
			appStore.setIsLoading(false)
		}
	}

	useEffect(() => {
		fetchAllData()
	}, []);

	return { fetchedLocations, fetchAllData, userDetails }
}
